import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { APP_NAME } from '../../app.config';

export default function SubNavbar({ title, header, subHeader, subHeaderOnlyView, subHeaderState }) {
    const location = useLocation();
    const path = location?.pathname
    let splitPath = path?.split('/')

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box">
                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><Link to="/" className='linkdata'>{APP_NAME}</Link></li>
                                <li className="breadcrumb-item"><Link to={'/' + splitPath?.[1]}>{header}</Link></li>
                                {subHeader ?
                                    subHeaderState ?
                                        <li className="breadcrumb-item"><Link to={'/' + splitPath?.[1] + '/' + splitPath?.[2]} state={subHeaderState}>{subHeader}</Link></li>
                                        :
                                        <li className="breadcrumb-item"><Link to={'/' + splitPath?.[1] + '/' + splitPath?.[2]}>{subHeader}</Link></li>
                                    :
                                    <></>
                                }
                                {subHeaderOnlyView ?
                                    <li className="breadcrumb-item"><a>{subHeaderOnlyView}</a></li> : <></>
                                }
                            </ol>
                        </div>
                        <h4 className="page-title">{title}</h4>
                    </div>
                </div>
            </div>
        </>
    )
}
